import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=4c676fb5"
import script from "./TagEditor.vue?vue&type=script&lang=js"
export * from "./TagEditor.vue?vue&type=script&lang=js"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=4c676fb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports